<div class="row clearfix">
  <div class="card bg-accent p-2">
    <div class="card-header bg-primary text-primary">
      <h2> Кнопки</h2>
    </div>
    <div class="card-body bg-primary">
      <div class="row">
        <div class="col">
          <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
            <div class="pb-2">
              <md-button color="primary">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="primary-stroked">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="primary-text">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="primary-opacity">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
            <div class="pb-2">
              <md-button color="accent">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="accent-stroked">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="accent-text">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="accent-opacity">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
            <div class="pb-2">
              <md-button color="warn">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="warn-stroked">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="warn-text">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="warn-opacity">
                <mat-icon>print</mat-icon> Печатная форма
              </md-button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
            <div class="pb-2">
              <md-button color="primary">
                <mat-icon>add_circle</mat-icon> Создать
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="primary-stroked">
                <mat-icon>add_circle</mat-icon> Создать
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="primary-text">
                <mat-icon>add_circle</mat-icon> Создать
              </md-button>
            </div>
            <div class="pb-2">
              <md-button color="primary-opacity">
                <mat-icon>add_circle</mat-icon> Создать
              </md-button>
            </div>
          </div>


        </div>
      </div>

    </div>
  </div>
</div>

<div class="row clearfix">
  <div class="card bg-accent p-2">
    <div class="card-header bg-primary text-primary">
      <h2> Checkbox</h2>
    </div>
    <div class="card-body bg-primary">
      <form [formGroup]="form">
        <div class="row">
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-checkbox color="primary" formControlName="primary">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="primary-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="primary-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="primary-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-checkbox color="accent" formControlName="accent">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="accent-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="accent-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="accent-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-checkbox color="warn" formControlName="warn">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="warn-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="warn-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="warn-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-checkbox>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-checkbox color="primary">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="primary-stroked">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="primary-text">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-checkbox>
              </div>
              <div class="pb-2">
                <md-checkbox color="primary-opacity">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-checkbox>
              </div>
            </div>            
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="row clearfix">
  <div class="card bg-accent p-2">
    <div class="card-header bg-primary text-primary">
      <h2> Input Search</h2>
    </div>
    <div class="card-body bg-primary">
      <form [formGroup]="form">
        <div class="row">
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-search 
                  color="primary" 
                  formControlName="selectSearch"
                  [data]="data"
                  (inputEmit)="search($event)"
                  >
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="primary-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="primary-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="primary-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-search color="accent">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="accent-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="accent-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="accent-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-search color="warn">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="warn-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="warn-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="warn-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-search>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-search color="primary">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="primary-stroked">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="primary-text">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-search>
              </div>
              <div class="pb-2">
                <md-input-search color="primary-opacity">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-search>
              </div>
            </div>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>

<div class="row clearfix">
  <div class="card bg-accent p-2">
    <div class="card-header bg-primary text-primary">
      <h2> Input Autocomplete</h2>
    </div>
    <div class="card-body bg-primary">
      <form [formGroup]="form">
        <div class="row">
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-autocomplete
                  color="primary" 
                  formControlName="selectSearch"
                  [data]="data"
                  (inputEmit)="search($event)"
                  >
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-autocomplete color="accent">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="accent-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="accent-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="accent-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-autocomplete color="warn">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="warn-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="warn-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="warn-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-autocomplete color="primary">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-stroked">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-text">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-opacity">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>

<div class="row clearfix">
  <div class="card bg-accent p-2">
    <div class="card-header bg-primary text-primary">
      <h2> Select </h2>
    </div>
    <div class="card-body bg-primary">
      <form [formGroup]="form">
        <div class="row">
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-select
                  color="primary" 
                  [data]="data"
                  >
                </md-select>
              </div>
              <div class="pb-2">
                <md-select color="primary-stroked">

                </md-select>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-autocomplete color="accent">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="accent-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="accent-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="accent-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-autocomplete color="warn">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="warn-stroked">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="warn-text">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="warn-opacity">
                  <mat-icon>print</mat-icon> Печатная форма
                </md-input-autocomplete>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex flex-column align-items-center p-2" style="border: 2px dotted gray;">
              <div class="pb-2">
                <md-input-autocomplete color="primary">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-stroked">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-text">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-autocomplete>
              </div>
              <div class="pb-2">
                <md-input-autocomplete color="primary-opacity">
                  <mat-icon>add_circle</mat-icon> Создать
                </md-input-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>